import Vue from 'vue'

Vue.mixin({
    methods: {
        $_useMessage_error(payload = {}) {
            const { showClose = false, duration = 2000, message, offset = 32 } = payload
            this.$message.error({
                showClose,
                duration,
                message,
                type: "error",
                offset
            })
        }
    }
})


// WEBPACK FOOTER //
// ./src/minxins/useMessage.js